import React from 'react';
import { motion } from 'framer-motion';
import { TabContainer, Section, SectionDescription } from '../shared/TabStyles';
import { itemVariants } from './styles/TipsTabStyles';
import IdealPromptAnatomy from './TipsTabSections/IdealPromptAnatomy';
import CorePromptingTechniques from './TipsTabSections/CorePromptingTechniques';
import StayingOrganized from './TipsTabSections/StayingOrganized';
import FavouritePrompts from './TipsTabSections/FavouritePrompts';
import CommonPitfallsSection from './TipsTabSections/CommonPitfallsSection';

const TipsTab = () => {
  return (
    <TabContainer>
      <Section>
        <IdealPromptAnatomy />
      </Section>
      <Section>
        <CorePromptingTechniques />
      </Section>
      <Section>
        <StayingOrganized />
      </Section>
      <Section>
        <FavouritePrompts />
      </Section>
      <Section>
        <CommonPitfallsSection />
      </Section>
    </TabContainer>
  );
};

export default TipsTab; 